import React from 'react'

export const InteractionLayer = ({ onUserClick }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div onClick={onUserClick} className="interaction_layer" />
)
